import { Content } from './types';

export default (content: Content) => ({
  label: content.title.label ?? undefined,
  color: content.title.color ?? undefined,
  htmlTag: content.title.htmlTag ?? undefined,
  subtitle: content.subtitle ?? undefined
});
